import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=980f46fc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=980f46fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980f46fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('980f46fc')) {
      api.createRecord('980f46fc', component.options)
    } else {
      api.reload('980f46fc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=980f46fc&scoped=true&", function () {
      api.rerender('980f46fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DeedtC49U5Gc/JS/comp/PopupBox.vue"
export default component.exports